import { combineReducers } from "redux";
import home from "./home";
import common from "./common";
import prescription from "./presubscription";
import postsubscription from "./postsubscription";

export const reducers = combineReducers({
  home,
  common,
  prescription,
  postsubscription,
});
